import React from "react";

type PrimaryButtonProps = {
  children: React.ReactNode;
  onClick?: () => void;
  type?: "button" | "submit" | "reset";
  disabled?: boolean | undefined;
  className?: string;
};

const PrimaryButton: React.FC<PrimaryButtonProps> = React.memo(({
  children,
  onClick,
  type = "button",
  disabled = false,
  className = "",
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      disabled={disabled}
      className={`
        px-4 py-2
        text-white
        bg-[var(--dr-dark)]
        hover:bg-[var(--dr-dark-var)]
        transition-colors
        disabled:opacity-60 disabled:cursor-not-allowed
        rounded
        ${className}
      `}
    >
      {children}
    </button>
  );
});

export default PrimaryButton;
